import React from 'react';
import noop from 'lodash/noop';
import { CanvasStateProvider } from 'redhotmagma-graphics-editor/CanvasInterface/CanvasProvider';

import IconDelete from '@material-ui/icons/Delete';
import IconRotate from '@material-ui/icons/RotateRight';
import IconScale from '@material-ui/icons/UnfoldMore';

import Designer from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Designer';
import AddVisualElement from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/AddVisualElement';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth/withWidth';

import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const StandardToolboxWithCanvasState = withWidth()(
  ({ width }) => isWidthUp('sm', width) && ( // desktop only, for mobile it's rendered in the sidebar, see Screen.js
  <div className="noShrink" style={{ paddingTop: 8, pointerEvents: 'none', position: 'relative' }}>
    <AddVisualElement />
  </div>
  ),
);

const renderStandardToolbox = ({ upload, components: { StandardToolbox } }) => (
  <StandardToolbox {...{ upload }}>
    {({ canvas }) => (
      <CanvasStateProvider canvas={canvas} />
    )}
  </StandardToolbox>
);

const toolboxButtonStyle = {
  width: 40,
  height: 40,
  padding: 0,
  border: '1px solid rgba(0,0,0,0.23)',
  boxSizing: 'border-box',
  borderRadius: 3,
  background: 'white',
  outline: 0,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  color: '#282828',
};
const transformTopRight = { transform: 'translate(0%, -100%)' };
const transformBottomRight = { transform: 'translate(0%, 0%)' };
const transformBottomLeft = { transform: 'translate(-100%, 0%)' };

const renderInlineToolButton = ({
  positionName,
  onScalingChange,
  onRotationChange,
  onDeleteClick,
  components: { InlineToolboxButton },
}) => {
  switch (positionName) {
    case 'topRight':
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformTopRight }}
          onTouchStart={onRotationChange}
          onMouseDown={onRotationChange}
        >
          <IconRotate style={{ alignSelf: 'center' }} />
        </InlineToolboxButton>
      );
    case 'bottomRight':
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformBottomRight }}
          onTouchStart={onScalingChange}
          onMouseDown={onScalingChange}
        >
          <IconScale style={{ transform: 'rotate(-45deg)', alignSelf: 'center' }} />
        </InlineToolboxButton>
      );
    case 'bottomLeft':
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformBottomLeft }}
          onClick={onDeleteClick}
        >
          <IconDelete style={{ alignSelf: 'center' }} />
        </InlineToolboxButton>
      );
    case 'topLeft':
      // not used
      return null;
  }
};

const renderAngleLabel = (angleLabel) => <Typography>{angleLabel}</Typography>;

const renderInlineToolbox = ({ components: { InlineToolbox } }) => (
  <InlineToolbox renderToolboxButton={renderInlineToolButton} renderAngleLabel={renderAngleLabel} />
);

renderInlineToolButton.propTypes = {
  positionName: PropTypes.string,
  onScalingChange: PropTypes.func,
  onRotationChange: PropTypes.func,
  onDeleteClick: PropTypes.func,
  components: PropTypes.element,
};
renderInlineToolbox.propTypes = {
  components: PropTypes.element,
};

renderStandardToolbox.propTypes = {
  upload: PropTypes.array,
  components: PropTypes.element,
};
export const DefaultDesigner = (props) => (
  <Designer
    renderStandardToolbox={renderStandardToolbox}
    renderSelectionToolbox={() => null /* disable the default */}
    renderInlineToolbox={renderInlineToolbox}
    renderRulers={getConf('displayEditorRulers', true) ? null : noop}
    fillContainer
    {...props}
  />
);
